import React, { useState, useRef } from "react";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";

const FormControlSearchWithAPI = ({
  size,
  id,
  setIsPopupOpen,
  className,
  placeholder,
  onChange,
  onKeyPress,
  screen,
  onClearText,
  ...rest
}) => {
  const [showClear, setShowClear] = useState(false);
  const inputElem = useRef(null);
  const onClear = () => {
    if (!onClearText) {
      inputElem.current.value = "";
      onChange({
        target: {
          value: "",
        },
      });
      setShowClear(false);
      if (screen === "mapper" && setIsPopupOpen) {
        setIsPopupOpen(false);
      }
    } else {
      onClearText();
      inputElem.current.value = "";
      onChange({
        target: {
          value: "",
        },
      });
      setShowClear(false);
    }
  };

  const buttonClass =
    screen === "plan-group-home"
      ? "close-button-pg"
      : "close-button-wrapper" || "sponsor-employee"
      ? "close-button-sponsor"
      : "close-button-wrapper";
  const iconClass =
    screen === "plan-group-home" || "sponsor-employee"
      ? "search-with-api-clear-button h-100 black"
      : "close-button";
  const onMouseMove = () => {
    if (inputElem.current.value) {
      setShowClear(true);
    }
  };
  // const onMouseOut = () => {
  //   setShowClear(false);
  // };
  const handleChange = (e) => {
    e.preventDefault();
    if (inputElem.current.value) {
      setShowClear(true);
    } else {
      setShowClear(false);
    }
    onChange(e);
  };

  const Width = screen === "payroll-listing" ? "600px" : "";

  const closeButtonWrapperClass = inputElem?.current?.value ? "active" : "";
  return (
    <>
      <div className="form-control-seach-text" style={{ width: Width }}>
        <Form.Control
          style={{
            height: "2.5rem",
            border: "1px solid #949494",
            borderRight: "0",
          }}
          ref={inputElem}
          {...rest}
          size={size}
          id={id}
          className={className}
          placeholder={placeholder}
          onChange={handleChange}
          onKeyPress={onKeyPress}
          type="input"
        />
      </div>
      {showClear && (
        <div
          className={`${buttonClass} ${closeButtonWrapperClass}`}
          onMouseMove={onMouseMove}
        >
          <button className={iconClass} type="button" onClick={onClear}>
            <FontAwesomeIcon
              icon={faTimes}
              size={size || "2x"}
              style={
                screen == "mapper" && {
                  fontSize: "24px",
                  marginTop: "5px",
                }
              }
            />
          </button>
        </div>
      )}
    </>
  );
};

export default FormControlSearchWithAPI;
